import { IRole, IUsers } from 'src/typings/user';
import { IComplex, IDeveloper } from 'src/typings/complexes';
import { Hydra } from 'src/api/hydraResponse';
import { ComplexStatus } from 'src/constants/complexStatus';

export type IManageUserBase = Pick<IUsers, '@type' | '@id' | 'id' | 'email' | 'username' | 'role' | 'complexes' | 'developers'> & {
  status: IUsersManageStatuses;
}

export type IManageUser = IManageUserBase & {
  complexesLinkedCount: number;
  complexesTotalCount: number;
}

export interface IUsersFilterInitial {
  developers: IDeveloper[];
  roles: IRole[];
  statuses: IUsersManageStatuses[]
}
export interface IUsersManageInitial {
  filters: IUsersFilterInitial;
  users: Hydra<IManageUser[]>,
}

export type IUserCreateDeveloper = Pick<IDeveloper, '@id' | '@type' | 'id' | 'name'>;
export type IUserCreateComplexes = Pick<IComplex, '@id' | '@type' | 'id'> & {title?: string, status?: ComplexStatus};
export type IUserCreateRole = Pick<IRole, '@id' | '@type' | 'id' | 'name'>;

type IUsersUpsertInitialUser = Pick<IUsers, '@id' | '@type' | '@context' | 'id' | 'email' | 'role' | 'username'>;
export type IDeveloperWithSharedComplexes = Pick<IDeveloper, '@id' | '@type' | 'id' > & { name: string, complexes: IUserCreateComplexes[]}
export interface IUsersUpsertInitial {
  authenticatedUser: IUsersUpsertInitialUser &
    { status?: ComplexStatus, assignableRoles: IRole[], developersWithSharedComplexes: IDeveloperWithSharedComplexes[] }
  editableUser?: IUsersUpsertInitialUser & { developersWithSharedComplexes: IDeveloperWithSharedComplexes[] };
  // developers: IUserCreateDeveloper[];
  // complexes: IUserCreateComplexes[];
  // roles: IUserCreateRole[];
  // user?: IManageUserBase;
}

export interface IUserCreateValidation {
  title: 'Validation Failed',
  violations: IUserCreateViolation[],
}

interface IUserCreateViolation {
  propertyPath: string;
  message: string;
}

export type UserRow = {
  id: number;
  username: string;
  email: string;
  role: string;
};

export interface ISaveUserData {
  users: UserRow[],
  complexes: string[],
  developers: string[],
}

export enum IUsersManageStatuses {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}
